import Papa from "papaparse";
import { saveAs } from "file-saver";

async function saveDownload(data, title, { order = "desc" } = {}) {
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error("Data is empty.");
  }

  try {
    // Reorder: bottom-up by default
    const ordered = order === "desc" ? [...data].reverse() : [...data];

    const flattenedData = ordered.map((item) => {
      const flattenedItem = { ...item };
      for (const key in flattenedItem) {
        const val = flattenedItem[key];
        if (Array.isArray(val) || (val && typeof val === "object")) {
          flattenedItem[key] = JSON.stringify(val);
        }
      }
      return flattenedItem;
    });

    const csvContent = Papa.unparse(flattenedData);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    await saveAs(blob, `${title}.csv`);
  } catch (error) {
    throw new Error(
      "An error occurred while generating or saving the CSV file."
    );
  }
}

export default saveDownload;
